import React, { useState } from 'react'
import styles from './styles.module.css'

function EmailPhone ({ record }) {
  const [showAllEmails, setShowAllEmails] = useState(false)
  const [showAllPhones, setShowAllPhones] = useState(false)

  const toggleEmails = () => setShowAllEmails(!showAllEmails)
  const togglePhones = () => setShowAllPhones(!showAllPhones)

  const emailsToShow = showAllEmails
    ? record.emails || []
    : (record.emails || []).slice(0, 4)

  // Extract the phone numbers as strings
  const extractPhoneNumbers = phones => {
    return phones.map(phone =>
      typeof phone === 'object' ? phone.number : phone
    )
  }

  const allPhones = extractPhoneNumbers([
    ...(record.phones || []),
    ...(record.phoneNumbers || [])
  ])
  const phonesToShow = showAllPhones ? allPhones : allPhones.slice(0, 4)

  return (
    <div className={styles.emailPhoneContainer}>
      <section className={styles.sectionContainer}>
        <h1 className={styles.header}>Emails</h1>
        {emailsToShow.length > 0 ? (
          emailsToShow.map((email, index) => (
            <div key={index} className={styles.item}>
              <span className={styles.text}>{email}</span>
            </div>
          ))
        ) : (
          <div className={styles.item}>
            <span className={styles.text}>N/A</span>
          </div>
        )}
        {(record.emails || []).length > 4 && (
          <span className={styles.expand} onClick={toggleEmails}>
            {showAllEmails
              ? 'Show Less'
              : `Expand All (${(record.emails || []).length})`}
          </span>
        )}
      </section>

      <section className={styles.sectionContainer}>
        <h1 className={styles.header}>Phones</h1>
        {phonesToShow.length > 0 ? (
          phonesToShow.map((phone, index) => (
            <div key={index} className={styles.item}>
              <span className={styles.text}>{phone}</span>
            </div>
          ))
        ) : (
          <div className={styles.item}>
            <span className={styles.text}>N/A</span>
          </div>
        )}
        {allPhones.length > 4 && (
          <span className={styles.expand} onClick={togglePhones}>
            {showAllPhones ? 'Show Less' : `Expand All (${allPhones.length})`}
          </span>
        )}
      </section>
    </div>
  )
}

export default EmailPhone
